import {TempUploadRequest, TempUploadResponse} from "../model/tempUpload";
import {TempUploadDataSource} from "./TempUploadDataSource";


export class TempUploadService {
    constructor(private dataSource: TempUploadDataSource) {}

    async uploadToTemp(request: TempUploadRequest): Promise<TempUploadResponse> {
        const formData = new FormData();

        for (let i = 0; i < request.files.length; i++) {
            const fileInfo = request.files[i];
            formData.append(`files[${i}]`, fileInfo.file);
            formData.append(`fileNames[${i}]`, fileInfo.originalName);
            formData.append(`extensions[${i}]`, fileInfo.extension);
        }

        return await this.dataSource.uploadToTemp(formData);
    }
}